$(document).ready(function() {
    // Data-Table, erst ab 11 Table-Rows
    if ($('.table-data-table').length > 0 && $('.table-data-table tbody tr').length > 10) {
        let langFile = '//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/German.json';
        if ($('html').attr('lang') == "en") {
            langFile = '//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/English.json';
        }
        if ($('html').attr('lang') == "cs") {
            langFile = '//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Czech.json';
        }
        if ($('html').attr('lang') == "nl") {
            langFile = '//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Dutch.json';
        }
        if ($('html').attr('lang') == "pl") {
            langFile = '//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/Polish.json';
        }
        if ($(window).width() < 1170) {
            $('.table-data-table').DataTable({
                "language": {
                    url: langFile
                },
                "pagingType": "simple",
                ordering: false,
                searching: false
            });
        } else {
            $('.table-data-table').DataTable({
                "language": {
                    url: langFile
                },
                ordering: false,
                searching: false
            });
        }
    }

    /* VERANSTALTUNGSDETAILSEITE */
    $('.ttgVeranstaltungTermineButton').click(function() {

        $('#ttgAccVeranstaltungstermine').trigger('click');
        var termineOffset = $('#ttgAccordionVeranstaltungstermine').offset();

        $('html, body').animate({
            scrollTop: (termineOffset.top - 85)
        }, 500);

    });

    $('.ttgVeranstaltungOrteButton').click(function() {

        $('#ttgAccVeranstaltungsorte h3 a').trigger('click');
        var orteOffset = $('#ttgAccVeranstaltungsorte').offset();

        $('html, body').animate({
            scrollTop: (orteOffset.top - 85)
        }, 500);

    });

    //Webcam Zeitraffer
    $('#startZeitraffer').click(function() {
        $(this).closest('div').addClass('zeitrafferActive');
        $('#zeitraffer').carousel('cycle');
    });

    $('#stopZeitraffer').click(function() {
        $(this).closest('div').removeClass('zeitrafferActive');
        $('#zeitraffer').carousel('pause');
    });

    // Webcam Bild beim ersten Aufruf noch mal asynchron nachladen
    if ($('.camPicDetails #lastPic picture').length > 0) {
        var webcamImg = $('.camPicDetails #lastPic');
        $.ajax({
            method: 'POST',
            url: "/index.php?id=" + rootPage + "&type=1900&L=" + webcamImg.data('syslanguageuid'),
            data: {
                experienceId: webcamImg.data('experienceid'),
                webExperienceId: webcamImg.data('webexperienceid'),
                tourdataId: webcamImg.data('tourdataid'),
                lang: webcamImg.data('lang'),
                sysLanguageUid: webcamImg.data('syslanguageuid')
            },
            success: function(response, status, xhr) {
                $('.camPicDetails #lastPic').html(response);
                setTimeout(function() {
                    $('#webcam-last-update').html(webcamImg.data('lastupdate')).attr('data-async', 'true');
                }, 500);
            }
        });
    }

    //webcam Carousel
    if ($('.camPic24h').length > 0 && $(window).width() >= 1170) {
        var $list = $("#last24hPicForPic");
        var next = $list.data('next');
        var prev = $list.data('prev');

        var slidesToShow = 4;
        if ($(window).width() < 1170) {
            slidesToShow = 1;
        }

        if ($list.find('.ttg-carousel-item').length > slidesToShow) {
            $list.on('init', function(event, slick, currentSlide) {
                $list.find('.slick-slide a').attr('tabindex', -1);
                $list.find('.slick-slide button').attr('tabindex', -1);
                $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
                $list.find('.slick-slide.slick-active button').removeAttr('tabindex');
                color_indicators(1, slick.$list.parent().next(), slidesToShow);

                slick.$list.parent().next().show();
            });

            $list.slick({
                accessibility: false,
                slidesToShow: slidesToShow,
                variableWidth: true,
                swipeToSlide: true,
                infinite: false,
                slide: '.ttg-carousel-item',
                prevArrow: '<button class="slick-prev" type="button"><span class="fas fa-chevron-left" aria-hidden="true"></span><span class="sr-only">' + prev + '</span></button>',
                nextArrow: '<button class="slick-next" type="button"><span class="fas fa-chevron-right" aria-hidden="true"></span><span class="sr-only">' + next + '</span></button>',
                responsive: [{
                    breakpoint: 1680,
                    settings: {
                        slidesToShow: 3,
                    }
                }]
            }).on('afterChange', function(event, slick, currentSlide) {
                $list.find('.slick-slide a').attr('tabindex', -1);
                $list.find('.slick-slide button').attr('tabindex', -1);
                $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
                $list.find('.slick-slide.slick-active button').removeAttr('tabindex');
            }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                color_indicators(nextSlide + 1, slick.$list.parent().next(), slidesToShow);
            });
        } else {
            $('.camPic24h' + uid + " .slider-indicators").hide();
        }
    }

    // zum Teil ausgeblendete Telefonnummer per Klick einblenden
    $(document).on("click", "#ttgTourdataKontakt .ttgShowTelNr", function(e) {
        e.preventDefault();
        $('.ttgTelNrPartial').removeClass('ttgTelNrPartial').addClass('ttgTelNrPartialInactive');
        $('#ttgTourdataKontakt .ttgShowTelNr').remove();
    });

    //PDF MODAL
    $("body").on("click", ".ttgButtonLinkPDF", function(e) {
        e.preventDefault();
        openDialog($(this).data("target").replace('#', ''), $(this));
    });

    $("body").on("click", "#ttgModalPdfPrintCloseButton", function(e) {
        aria.getCurrentDialog().close();
    });

    $('body').on('keydown', '.ttgTourdataPdfModal', function(e) {
        var code = e.which;
        // 27 = ESC
        if ((code === 27)) {
            $('#ttgModalPdfPrintCloseButton').click();
        }
    });

    //PDF MODAL
    $("body").on("click", ".ttgDetailPDF .ttgPdfText a", function(e) {
        e.preventDefault();
        openDialog($(this).attr("href").replace('#', ''), $(this));
    });

    $('.ttgTourdataPdfModal').on('shown.bs.modal', function() {
        $('.ttgTourdataGeneratePdfBtn').show();
    });

    //Distanz von Liste über section übergeben und auslesen
    let hashObj = generateObjectFromHash(window.location.hash);
    if (hashObj.distance) {
        var km = hashObj.distance / 1000;
        var mOrKm = (hashObj.distance >= 1000) ? km.toFixed(1).replace('.', ',') + ' km' : hashObj.distance + ' m';
        mOrKm = mOrKm.replace(',0', '');
        $('.ttgTourdataDetailOrt').text(mOrKm + " | " + $('.ttgTourdataDetailOrt').text());
    }

    if (window.location.hash) {
        $('img#qrCode').attr('src', ($('img#qrCode').attr('src') + encodeURIComponent(window.location.hash)));
    }

    // wenn man von der selben Domain auf eine TOURDATA Detailseite kommt, soll zurück zur Übersicht
    if (document.referrer.indexOf(location.protocol + "//" + location.host) < 0) {
        $('.ttgZurueckZurUebersichtButton').hide();
    }

    // if ($('.ttgZurueckZurUebersichtButton').length && !$('#ttgHeaderOnDetailSite img').length && $(window).width() >= 975) {
    //     $('.ttgZurueckZurUebersichtButton').css('margin-top', '45px');
    // }

    // bei Berichten das XML neu laden
    if ($('.ttgTourdataDetailseitePoi').data('bericht') == 1) {
        $.ajax({
            method: 'POST',
            url: "/index.php?id=" + rootPage + "&type=1870&L=" + $('.ttgTourdataDetailseitePoi').data('syslanguageuid'),
            data: {
                experienceId: $('.ttgTourdataDetailseitePoi').data('experienceid'),
                tourdataId: $('.ttgTourdataDetailseitePoi').data('tourdataid'),
                lang: $('.ttgTourdataDetailseitePoi').data('lang'),
                sysLanguageUid: $('.ttgTourdataDetailseitePoi').data('syslanguageuid')
            },
            success: function(response, status, xhr) {
                $('#ttg-ajax-reload-berichtsdaten').html(response);
                createRelationSlick($(".ttg-relation-carousel"));

                // Tooltips initialisieren
                if ($('.ttgTourdataDetailseite .simpletooltip_container').length <= 0) {
                    $('.js-tooltip').each(function() {
                        accessibleSimpleTooltipAria.apply(this);
                    });
                }
            }
        });
    }

    // auf der Tourendetailseite den Loipenbericht per Ajax nachladen
    if ($('.ttg-loipe-in-betrieb').length > 0) {
        var targetObj = $('.ttg-loipe-in-betrieb');
        $.ajax({
            method: 'POST',
            url: "/index.php?id=" + rootPage + "&type=2010&L=" + targetObj.data('syslanguageuid'),
            data: {
                experienceId: targetObj.data('experienceid'),
                tourdataId: targetObj.data('tourdataid'),
                lang: targetObj.data('lang'),
                sysLanguageUid: targetObj.data('syslanguageuid')
            },
            success: function(response, status, xhr) {
                targetObj.html(response);
            }
        });
    }

    //Youtube Cookie overlay
    if ($(".ttgTourdataDetailseite").length) {
        $('.ttgVideo').each(function() {
            if ($.cookie('cookieConsented-marketing') == '1' && $.cookie('cookieConsented-marketing') == "1" && $.cookie('cookieConsented-personalization') == "1") {
                if (!$(this).data("overlay")) {
                    if ($(this).find(".ttgNCEVideoPreview").length) {
                        $(this).find(".ttgNCEVideoOverlay").append('<button class="ttgFCEVideoPlayButton ttgColoredButton" data-uid="' + $(this).data("uid") + '" data-youtubeId="' + $(this).data("youtubeid") + '" >' + $(this).data("playvideotext") + '</button>');
                    } else {
                        $(this).find(".ttgFCEVideoContainer").append('<iframe class="ttgIframeVideoInImageGallery lazyload" width="100%" allowfullscreen data-src="//www.youtube-nocookie.com/embed/' + $(this).data("youtubeid") + '?rel=0&showinfo=0&autohide=0&modestbranding=1&controls=1&wmode=transparent" frameborder="0"></iframe>');
                    }
                }
            } else {
                if (!$(this).data("overlay")) {
                    if ($(this).find(".ttgNCEVideoPreview").length) {
                        $(this).find(".ttgNCEVideoOverlay").append('<button id="ttgFCEVideoPlayButtonOne' + $(this).data("uid") + '" class="ttgFCEVideoPlayButton ttgColoredButton" data-uid="' + $(this).data("uid") + '" data-youtubeId="' + $(this).data("youtubeid") + '">' + $(this).data("playvideotext") + '</button><div id="ttgFCEVideoPlayButtonTwo' + $(this).data("uid") + '" style="display: none"><a href="https://www.youtube.com/watch?v=' + $(this).data("youtubeid") + '"class="ttgFCEVideoPlayButton ttgColoredButton" target="_blank">' + $(this).data("tovideotext") + '</a></div>');
                        $(this).find(".ttgNCEVideoPreview").append('<div id="ttgVideoOverlayOne' + $(this).data("uid") + '" class="ttgVideoOverlayOne"><p>' + $(this).data("consenttextone") + '</p><a href="#" class="ttgVideoButtonDeny" role="button" data-uid="' + $(this).data("uid") + '">' + $(this).data("consentdeny") + '</a></div><div id="ttgVideoOverlayTwo' + $(this).data("uid") + '" class="ttgVideoOverlayOne" style="display: none"><p>' + $(this).data("consenttexttwo") + '</p></div>');
                    } else {
                        $(this).find(".ttgFCEVideoContainer").append('<div class="ttgNCEVideoOverlay ttgNCEVideoPreview"><button id="ttgFCEVideoPlayButtonOne' + $(this).data("uid") + '" class="ttgFCEVideoPlayButton ttgColoredButton" data-uid="' + $(this).data("uid") + '" data-youtubeId="' + $(this).data("youtubeid") + '">' + $(this).data("playvideotext") + '</button><div id="ttgFCEVideoPlayButtonTwo' + $(this).data("uid") + '" style="display: none"><a href="https://www.youtube.com/watch?v=' + $(this).data("youtubeid") + '" class="ttgFCEVideoPlayButton ttgColoredButton" target="_blank">' + $(this).data("tovideotext") + '</a></div></div><div id="ttgVideoOverlayOne' + $(this).data("uid") + '" class="ttgVideoOverlayOne"><p>' + $(this).data("consenttextone") + '</p><a href="#" class="ttgVideoButtonDeny" role="button" data-uid="' + $(this).data("uid") + '">' + $(this).data("consentdeny") + '</a></div><div id="ttgVideoOverlayTwo' + $(this).data("uid") + '" class="ttgVideoOverlayOne" style="display: none"><p>' + $(this).data("consenttexttwo") + '</p></div>');
                        $(this).find(".ttgFCEVideoContainer").parent().addClass("ttgVideoContainerNoPic");
                    }
                }
            }
        });
        $(".ttgFCEVideoPlayButton").click(function() {
            var uid = $(this).data("uid");
            $("#ttgFCEVideoContainer" + uid).append('<iframe class="ttgIframeVideoInImageGallery lazyload" width="100%" data-src="//www.youtube-nocookie.com/embed/' + $(this).data("youtubeid") + '" frameborder="0"></iframe>');

            /* Vorschaubild verstecken */
            $("#ttgFCEVideoContainer" + uid).parent().removeClass("ttgVideoContainerNoPic");
            $('.ttgNCEVideoPreview' + uid).hide();
            $("#ttgVideoOverlayOne" + uid).hide();
            $("#ttgFCEVideoPlayButtonOne" + uid).hide();
        });
        $(".ttgVideoButtonDeny").click(function(e) {
            e.preventDefault();
            var uid = $(this).data("uid");

            $("#ttgVideoOverlayOne" + uid).hide();
            $("#ttgFCEVideoPlayButtonOne" + uid).hide();
            $("#ttgVideoOverlayTwo" + uid).show();
            $("#ttgFCEVideoPlayButtonTwo" + uid).show();
        });
    }

    // Gastro Öffnungszeiten auf der Detailseite per Ajax laden
    // zum Teil ausgeblendete Telefonnummer per Klick einblenden
    $(document).one("click", "#ttgAccordionOeffnungszeiten", function(e) {
        getOpeningHours($(this), '');
    });

    // weitere Öffnungszeiten laden
    $('body').on("click", "#ttgAccordionOeffnungszeiten #openingHoursAjaxResponse #btnVor, #ttgAccordionOeffnungszeiten #openingHoursAjaxResponse #btnZurueck", function(e) {
        e.preventDefault();
        getOpeningHours($("#ttgAccordionOeffnungszeiten"), $(this));
    });

    // Gastro Küchenzeiten auf der Detailseite per Ajax laden
    $(document).one("click", "#ttgAccordionKueche", function(e) {
        getKitchenHours($(this), '');
    });

    // weitere Küchenzeiten laden
    $('#ttgAccordionKueche').on("click", "#kitchenHoursAjaxResponse #btnVor, #kitchenHoursAjaxResponse #btnZurueck", function(e) {
        e.preventDefault();
        getKitchenHours($("#ttgAccordionKueche"), $(this));
    });

    // Veranstaltungen: Termine laden
    $(document).one("click", "#ttgAccVeranstaltungstermine", function(e) {
        getEvents($("#eventsAjaxResponse"), '');
    });

    // weitere Reisezeiträume laden
    $("#eventsAjaxResponse").on("click", "#btnVor, #btnZurueck", function(e) {
        e.preventDefault();
        getEvents($("#eventsAjaxResponse"), $(this));
    });

    // Datumsauswahl beim Veranstaltungen
    $('#eventsAjaxResponse').on("change", '#eventTermin', function(e) {
        $("#eventsAjaxResponse #btnVor").data('from', $("#eventTermin").val()).trigger("click");
    });


    //GPX Modal
    $("body").on("click", ".ttgButtonLinkGPXModal", function(e) {
        e.preventDefault();
        openDialog('ttgDisclaimerContent', $(this));
    });

    $("body").on("click", "#ttgDisclaimerContent .close", function(e) {
        aria.getCurrentDialog().close();
    });

    $('body').on('keydown', '.ttgTourdataPdfModal', function(e) {
        var code = e.which;
        // 27 = ESC
        if ((code === 27)) {
            $('#ttgDisclaimerContent .close').click();
        }
    });

    //Höhenprofil Modal
    $("body").on("click", "#ttgHoehenprofilModalLink", function(e) {
        e.preventDefault();
        openDialog('ttgHoehenprofilModal', $(this));
    });

    $("body").on("click", "#ttgHoehenprofilModal .close", function(e) {
        aria.getCurrentDialog().close();
    });

    $('body').on('keydown', '.ttgTourdataPdfModal', function(e) {
        var code = e.which;
        // 27 = ESC
        if ((code === 27)) {
            $('#ttgHoehenprofilModal .close').click();
        }
    });

    $(".ttgGpxDownloadLink").on("click", function() {
        if ($("#ttgSetDisclaimer").prop("checked") == true) {
            $("#disclaimerCheckBoxErrorText").hide().removeClass("required");
            if ($('#matomoTracking').length) {
                //Download tracking in Matomo
                _paq.push(['trackLink', $(this).attr("data-href"), 'download']);
            }
            window.location.href = $(this).attr("data-href");
            setTimeout(function() {
                $('#ttgDisclaimerContent').modal('hide');
            }, 4000);
        } else {
            $("#disclaimerCheckBoxErrorText").show().addClass("required");
        }
    });

    $('.ttg-relation-carousel').each(function() {
        createRelationSlick($(this));
    });

    $('.ttg-bilder-carousel').each(function() {
        createGallerySlick($(this));
    });

    if ($(window).width() < 1680) {
        $('.ttgTourdataDetailseiteIcons').each(function() {
            createEigenschaftenSlick($(this));
        });
    }

    // BILDERGALERIE Lightbox
    if ($(".ttg-bilder-carousel").data("nolightbox") == 0) {
        var nextElement = $(".ttg-bilder-carousel").data("next");
        var previousElement = $(".ttg-bilder-carousel").data("prev");
        var close = $(".ttg-bilder-carousel").data("close");

        $(document).on('click', '[data-toggle="lightbox"]', function(event) {
            var element = $(this);
            event.preventDefault();
            $(this).ekkoLightbox({
                leftArrow: "<span class=\"icon prev\"><span class='fas fa-chevron-left' aria-hidden='true'></span><p class='sr-only'>" + previousElement + "</p></span>",
                rightArrow: "<span class=\"icon next\"><span class='fas fa-chevron-right' aria-hidden='true'></span><p class='sr-only'>" + nextElement + "</p></span>",
                wrapping: 0,
                alwaysShowClose: true,
                onShown: function() {
                    $(".ekko-lightbox").attr("aria-modal", true);
                    $(".ekko-lightbox-nav-overlay a").attr("role", "button");
                    $(".ekko-lightbox .close").html('<span class="fas fa-times" aria-hidden="true"></span><span class="sr-only">' + close + '</span>').removeAttr("aria-label");
                },
                onHidden: function() {
                    element.focus();
                },
            });

        });
    }

    waAuslastung(); // Function in tdLists.js

    // WA Positionierung
    if ($(window).width() >= 975) {
        $('.ttgTourdataDetailseite .wa-auslastung').closest('.col-lg-4').height(
            $('.ttgTourdataDetailseite .wa-auslastung').closest('.row').height()
        );
        // $('.ttgTourdataDetailseite .wa-auslastung').css({
        //     position: 'absolute',
        //     bottom: 30
        // });
    }

    // wird in packages/ttg_tourdata/Resources/Private/Partials/Common/OrtAdresse.html aufgerufen
    /*
        @custom-solution: OOEVV-Widget Icon Einbindung
        @description: auf den TOURDATA Detailseiten soll bei ausgewählten Projekten ein Icon (Straßenbahn) angezeigt werden, bei Klick darauf hüpft man zum OÖVV Accordion / unter 440px wird das Icon nicht angezeigt
        @ticket: OOEAT-6620
        @projects: ausflugstipps.at, oberoesterreich.at
    */
    $('#ttgRbContentWrapper').on('click', '.jump-2-ooev-widget', function(e) {

        var $collapse = $('#ttgCollapseAnreise');
        var $widget = $('#ooevv-widget');

        // Accordion ist geschlossen → erst öffnen, dann scrollen
        if (!$collapse.hasClass('in') && !$collapse.hasClass('show')) {
            // Bootstrap 4+ nutzt 'show' statt 'in'
            $('#ttgAccordionAnreise .card .card-header h2 a').trigger('click');

            // Nach dem Öffnen warten, bis die Animation fertig ist
            $collapse.one('shown.bs.collapse', function() {
                scrollToWidget($widget);
            });
        } else {
            // Accordion ist schon offen → sofort scrollen
            scrollToWidget($widget);
        }

        function scrollToWidget($el) {
            if ($el.length > 0) {
                var offset = $el.offset();
                $('html, body').animate({
                    scrollTop: offset.top - 135
                }, 300);
            }
        }

    });

});

const getOpeningHours = function($obj, $btn) {

    let params = {};

    if ($obj.data('objecttype') == 'Gastro' || $obj.data('objecttype') == 'POI') {

        params.ObjectType = $obj.data('objecttype');
        params.ObjectID = $obj.data('objectid');
        // params.MetaExperience = $obj.data('metaexperience');
        params.MetaExperience = 'webarchitektur-meta';
        if ($btn.length > 0) {
            if ($btn.data('from')) {
                params.From = $btn.data('from');
            }
            if ($btn.data('back')) {
                params.Back = $btn.data('back');
            }
        }

        $.ajax({
            type: "POST",
            url: '/index.php?id=' + rootPage + '&type=1880&L=' + $obj.data('syslanguageuid'),
            data: params,
            beforeSend: function() {
                $('#openingHoursAjaxResponse').addClass('pause');
                spinner($('#openingHoursAjaxResponse'));
                $('#openingHoursAjaxResponse .loadingAnimation .results').text($obj.data('loading-text'));
                $('#openingHoursAjaxResponse .result').attr("aria-busy", true);
            },
            success: function(result) {
                $('#openingHoursAjaxResponse .result').html(result);
                $('#openingHoursAjaxResponse .loadingAnimation').remove();
                $('[data-toggle="tooltip"]').tooltip();
            },
            error: function() {
                //     //alert("error");
            },
            complete: function() {
                $('#openingHoursAjaxResponse').removeClass('pause');
                $('#openingHoursAjaxResponse .result').attr("aria-busy", false);
            }
        });
    }

};

const getKitchenHours = function($obj, $btn) {

    let params = {};

    if ($obj.data('objecttype') == 'Gastro') {

        params.ObjectType = $obj.data('objecttype');
        params.ObjectID = $obj.data('objectid');
        // params.MetaExperience = $obj.data('metaexperience');
        params.MetaExperience = 'webarchitektur-meta';
        if ($btn.length > 0) {
            if ($btn.data('from')) {
                params.From = $btn.data('from');
            }
            if ($btn.data('back')) {
                params.Back = $btn.data('back');
            }
        }

        $.ajax({
            type: "POST",
            url: '/index.php?id=' + rootPage + '&type=1910&L=' + $obj.data('syslanguageuid'),
            data: params,
            beforeSend: function() {
                $('#kitchenHoursAjaxResponse').addClass('pause');
                spinner($('#kitchenHoursAjaxResponse'));
                $('#kitchenHoursAjaxResponse .loadingAnimation .results').text($obj.data('loading-text'));
            },
            success: function(result) {
                $('#kitchenHoursAjaxResponse .result').html(result);
                $('#kitchenHoursAjaxResponse .loadingAnimation').remove();
                $('[data-toggle="tooltip"]').tooltip();
            },
            error: function() {
                //     //alert("error");
            },
            complete: function() {
                $('#kitchenHoursAjaxResponse').removeClass('pause');
            }
        });
    }

};

const createGallerySlick = function($list) {
    var next = $list.data('next');
    var prev = $list.data('prev');
    var name = $list.data('name');

    slidesToShow = 1;

    if ($list.find('.ttg-carousel-item').length > slidesToShow) {
        $list.on('init', function(event, slick, currentSlide) {
            name = slick.$list.data('name');
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide button').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
            $list.find('.slick-slide.slick-active button').removeAttr('tabindex');
            console.log($list.find('.slick-slide.slick-active button.ttgFCEVideoPlayButton'));
            $list.find('.slick-slide.slick-active .ttgVideoButtonDeny').removeAttr('tabindex');

            color_indicators(1, slick.$list.parent().next(), slidesToShow);
            slick.$list.parent().next().show();
        });

        $list.slick({
            accessibility: false,
            slidesToShow: slidesToShow,
            variableWidth: true,
            swipeToSlide: true,
            infinite: false,
            slide: '.ttg-carousel-item',
            prevArrow: '<button class="slick-prev" type="button"><span class="fas fa-chevron-left" aria-hidden="true"></span><span class="sr-only">' + prev + '</span></button>',
            nextArrow: '<button class="slick-next" type="button"><span class="fas fa-chevron-right" aria-hidden="true"></span><span class="sr-only">' + next + '</span></button>',
        }).on('afterChange', function(event, slick, currentSlide) {
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide button').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
            $list.find('.slick-slide.slick-active button').removeAttr('tabindex');
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            color_indicators(nextSlide + 1, slick.$list.parent().next(), slidesToShow);
        });
    }
};


const createEigenschaftenSlick = function($list) {

    $list.on('init', function(event, slick, currentSlide) {
        $list.find('.slick-slide').removeAttr('aria-hidden');
    });

    $list.slick({
        accessibility: false,
        variableWidth: true,
        swipeToSlide: true,
        infinite: false,
        slide: ".ttgIcon",
        arrows: false
    }).on('afterChange', function(event, slick, currentSlide) {
        $list.find('.slick-slide').removeAttr('aria-hidden');
    });

};

const createRelationSlick = function($list) {
    var next = $list.data('next');
    var prev = $list.data('prev');
    var name = $list.data('name');

    var slidesToShow = 2;
    if ($(window).width() < 1170) {
        slidesToShow = 1;
    }

    if ($list.find('.ttg-carousel-item').length > slidesToShow) {
        $list.on('init', function(event, slick, currentSlide) {
            name = slick.$list.data('name');
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');

            color_indicators(1, slick.$list.parent().next(), slidesToShow);
            slick.$list.parent().next().show();
        });

        $list.slick({
            accessibility: false,
            slidesToShow: slidesToShow,
            variableWidth: true,
            swipeToSlide: true,
            infinite: false,
            slide: '.ttg-carousel-item',
            prevArrow: '<button class="slick-prev" type="button"><span class="fas fa-chevron-left" aria-hidden="true"></span><span class="sr-only">' + prev + '</span></button>',
            nextArrow: '<button class="slick-next" type="button"><span class="fas fa-chevron-right" aria-hidden="true"></span><span class="sr-only">' + next + '</span></button>',
            responsive: [{
                breakpoint: 1650,
                settings: {
                    slidesToShow: 2,
                },
                breakpoint: 1470,
                settings: {
                    slidesToShow: 1,
                }
            }]
        }).on('afterChange', function(event, slick, currentSlide) {
            $list.find('.slick-slide a').attr('tabindex', -1);
            $list.find('.slick-slide.slick-active a').removeAttr('tabindex');
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            color_indicators(nextSlide + 1, slick.$list.parent().next(), slidesToShow);
        });
    }
};

const getEvents = function($obj, $btn) {

    let params = {};

    if ($obj.data('objecttype') == 'Event') {

        if ($('#ttgAccVeranstaltungstermine').attr('data-initial') == 'true') {
            params.Initial = true;
            $('#ttgAccVeranstaltungstermine').attr('data-initial', 'false');
        } else {
            params.Initial = false;
        }

        params.ObjectType = $obj.data('objecttype');
        params.ObjectID = $obj.data('objectid');
        params.ObjectTitle = $obj.data('objecttitle');
        // params.MetaExperience = $obj.data('metaexperience');
        params.MetaExperience = 'webarchitektur-meta';
        if ($btn.length > 0) {
            if ($btn.data('from')) {
                params.From = $btn.data('from');
            }
            if ($btn.data('back')) {
                params.Back = $btn.data('back');
            }
        }

        $.ajax({
            type: "POST",
            url: '/index.php?id=' + rootPage + '&type=1970&L=' + $obj.data('syslanguageuid'),
            data: params,
            beforeSend: function() {
                $('#ttgAccVeranstaltungstermine').addClass('pause');
                spinner($('#ttgAccVeranstaltungstermine'));
                $('#ttgAccVeranstaltungstermine .loadingAnimation .results').text($obj.data('loading-text'));
            },
            success: function(result) {
                $('#eventsAjaxResponse .result').html(result);
                $('#ttgAccVeranstaltungstermine .loadingAnimation').remove();
            },
            error: function() {
                //     //alert("error");
            },
            complete: function() {
                $('#ttgAccVeranstaltungstermine').removeClass('pause');

                if (params.Initial === true) {
                    $('#eventTermin').val($('#eventTermin').data('date')).trigger('change');
                }

                $('#eventsAjaxResponse .result .js-tooltip').each(function() {
                    accessibleSimpleTooltipAria.apply(this);
                });
            }
        });
    }

};